import { useMemo } from 'react';
import { DialogType, SelectOption } from '../../../@types';
import { CasinoGamesFilters } from '../../../@types/casino';
import { useCasinoProviderOptions } from '../../../hooks/useCasinoProviderOptions';
import useFilterForm from '../../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../../hooks/usePagination';
import { useCasinoCategories } from '../../../queries/casino';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import FormSelect from '../../molecules/FormSelect';

type FilterCasinoGamesData = Pick<CasinoGamesFilters, 'providerName' | 'aggregatorName' | 'categoryId' | 'gameType'>;

const DEFAULT_FORM_DATA: FilterCasinoGamesData = {
  providerName: undefined,
  aggregatorName: undefined,
  categoryId: undefined,
  gameType: undefined,
};

const AGGREGATOR_OPTIONS: SelectOption[] = [
  { id: '', name: 'All' },
  { id: 'GGA', name: 'GGA' },
  { id: 'GOLDGAMES', name: 'Gold Games' },
];

const GAME_TYPE_OPTIONS: SelectOption[] = [
  { id: '', name: 'All' },
  { id: 'Copies', name: 'Copies' },
  { id: 'Originals', name: 'Originals' },
];

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterCasinoGames = ({ changeQuery, closeModal }: Props) => {
  const { options: providerOptions, isLoading: providersLoading } = useCasinoProviderOptions();
  const { data: categories = [], isLoading: categoriesLoading } = useCasinoCategories();

  const { control, handleResetFilter, handleSubmit } = useFilterForm<FilterCasinoGamesData>({
    defaultData: DEFAULT_FORM_DATA,
    changeQuery,
  });

  const categoryOptions = useMemo<SelectOption[]>(
    () =>
      categories.map((category) => ({
        id: category._id,
        name: category.name,
      })),
    [categories]
  );

  return (
    <FilterDialogLayout
      label='casino games'
      onSave={handleSubmit}
      onClose={() => closeModal?.()}
      onReset={handleResetFilter}
    >
      <FormSelect
        control={control}
        name='providerName'
        label='Provider'
        options={providerOptions}
        disabled={providersLoading && !providerOptions.length}
      />
      <FormSelect control={control} name='aggregatorName' label='Aggregator' options={AGGREGATOR_OPTIONS} />
      <FormSelect
        control={control}
        name='categoryId'
        label='Category'
        options={categoryOptions}
        disabled={categoriesLoading && !categoryOptions.length}
      />
      <FormSelect control={control} name='gameType' label='Game Type' options={GAME_TYPE_OPTIONS} />
    </FilterDialogLayout>
  );
};

export default FilterCasinoGames;
